import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useSettings from '../hooks/useSettings';

function navLinksToText(navLinks) {
  return (navLinks || []).map((item) => `${item.label}|${item.href}`).join('\n');
}

function textToNavLinks(value) {
  return value
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const [label, href] = line.split('|');
      return { label: label?.trim() || 'Link', href: href?.trim() || '/' };
    });
}

export default function Settings() {
  const settingsApi = useSettings();
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [loadError, setLoadError] = useState(null);
  const [saveError, setSaveError] = useState(null);
  const [form, setForm] = useState({ siteTitle: '', siteDescription: '', navLinksText: '' });
  const [message, setMessage] = useState('');

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const data = await settingsApi.getSettings();
        setSettings(data);
        setForm({
          siteTitle: data.siteTitle || '',
          siteDescription: data.siteDescription || '',
          navLinksText: navLinksToText(data.navLinks || []),
        });
      } catch (err) {
        setLoadError(err);
      } finally {
        setLoading(false);
      }
    };
    loadSettings();
  }, []);

  const handleSave = async () => {
    setMessage('');
    setSaveError(null);
    setSaving(true);
    try {
      await settingsApi.updateSettings({
        siteTitle: form.siteTitle,
        siteDescription: form.siteDescription,
        navLinks: textToNavLinks(form.navLinksText),
      });
      setMessage('Settings saved successfully.');
    } catch (err) {
      setSaveError(err);
    } finally {
      setSaving(false);
    }
  };

  const error = loadError || saveError;

  return (
    <div className="stack gap-lg">
      <section className="card stack gap-md">
        <div>
          <h2>Globale Einstellungen</h2>
          <p className="muted">Seitenweite Metadaten und Titel verwalten.</p>
        </div>
        {loading ? <p>Lade Einstellungen…</p> : null}
        {message ? <div className="alert success">{message}</div> : null}
        {error ? <div className="alert error">{error.message}</div> : null}
        <label>
          Website-Titel
          <input value={form.siteTitle} onChange={(event) => setForm((current) => ({ ...current, siteTitle: event.target.value }))} />
        </label>
        <label>
          Website-Beschreibung
          <textarea rows="4" value={form.siteDescription} onChange={(event) => setForm((current) => ({ ...current, siteDescription: event.target.value }))} />
        </label>
        <div>
          <button className="button primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Speichert…' : 'Einstellungen speichern'}
          </button>
        </div>
      </section>

      {/* Navigation Banner Card */}
      <section className="card row between align-center" style={{ background: '#f8fafc', border: '1px solid #e2e8f0' }}>
        <div>
          <h3 style={{ margin: 0 }}>🧭 Menü & Navigation verwalten</h3>
          <p className="muted" style={{ margin: '0.25rem 0 0' }}>
            Erstelle und ordne Menüeinträge visuell mit Seiten- und Beitragswähler im Navigations-Modul.
          </p>
        </div>
        <Link to="/navigation" className="button secondary">
          Zum Menü-Editor &rarr;
        </Link>
      </section>
    </div>
  );
}
